<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useKanbanCWBridge } from 'dashboard/composables/useKanbanCWBridge';

const { hasKanbanCWBridge, openConversationWidget, onConversationStageChange } =
  useKanbanCWBridge();

const currentStage = ref(null);

const syncStageFromDom = () => {
  const button = document.getElementById('cw-kanban-header-btn');
  if (button?.classList.contains('has-stage')) {
    currentStage.value = {
      stageName: button.getAttribute('data-stage-name') || '',
    };
    return;
  }

  if (!button?.classList.contains('has-stage')) {
    currentStage.value = null;
  }
};

let removeStageListener = null;

onMounted(() => {
  removeStageListener = onConversationStageChange(event => {
    currentStage.value = event.detail?.currentStage || null;
  });
  syncStageFromDom();
});

onBeforeUnmount(() => {
  removeStageListener?.();
});
</script>

<template>
  <button
    v-show="hasKanbanCWBridge"
    id="cw-kanban-header-btn"
    type="button"
    class="inline-flex items-center justify-center min-w-0 gap-0.5 transition-all duration-100 ease-out border-0 rounded-lg outline outline-1 outline-transparent bg-transparent h-8 w-8 p-0 text-sm text-n-slate-11 hover:bg-n-alpha-2"
    :class="{ 'has-stage': !!currentStage }"
    :title="
      currentStage ? `Kanban: ${currentStage.stageName}` : 'Funções Extras'
    "
    @click.prevent.stop="openConversationWidget"
  >
    <!-- Custom product bridge: native conversation trigger that keeps the KanbanCW modal contract. -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  </button>
</template>
